import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {Location} from "@angular/common";
import {Keys, StorageService} from "../../service/storage.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {NomineeFormComponent} from "../../lender-nominee/nominee-form/nominee-form.component";
import {isEmpty} from "lodash";
import {Logger} from "../../utils/Logger";

@Component({
    selector: 'app-nominee',
    templateUrl: './lender-dashboard-nominee.component.html',
    styleUrls: ['./lender-dashboard-nominee.component.scss', './../profile.component.css', './../../../assets/styles/finzy-styles.scss']
})

export class LenderDashboardNomineeComponent implements OnInit, AfterViewInit {

    private location: Location;
    private storageService: StorageService;
    public finzyDomain: boolean;
    public otherDomain: boolean;
    public nomineeFormGroup: FormGroup;
    public isEdit: boolean;

    @ViewChild(NomineeFormComponent)
    nomineeFormComponent: NomineeFormComponent;

    constructor(location: Location, storageService: StorageService, formBuilder: FormBuilder) {
        this.location = location;
        this.storageService = storageService;
        this.nomineeFormGroup = formBuilder.group({})
    }

    public backToPreviousPage() {
        this.location.back();
    }

    ngOnInit(): void {
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
    }


    ngAfterViewInit(): void {
        this.disableForm();
    }

    public disableForm() {
        this.nomineeFormComponent.nomineeForm.disable();
        this.nomineeFormComponent.nomineeGuardianForm.disable();
        this.isEdit = false;
    }

    checkNomineeExists(): boolean {
        if (this.nomineeFormComponent) {
            return !isEmpty(this.nomineeFormComponent.prefilledNominee)
        }
    }

    async activateForm(): Promise<void> {
        this.nomineeFormComponent.nomineeForm.enable();
        this.nomineeFormComponent.nomineeGuardianForm.enable();
        this.isEdit = true;
    }

    async saveForm(): Promise<void> {
        try {
            if (this.nomineeFormComponent.isFormValid()) {
                if (this.nomineeFormComponent.validateTermsCheck()) {
                    await this.nomineeFormComponent.saveForm();
                    await this.nomineeFormComponent.initializeForm();
                    await this.disableForm();
                }
            }
        } catch (e) {
            Logger.log(`An error occurred while submitting nominee form ${JSON.stringify(e)}`);
        }
    }

    async cancelForm(): Promise<void> {
        await this.nomineeFormComponent.ngOnInit();
        this.disableForm();
    }
}
